import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/speaker-deck': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M213.9 296h-113.9c-55.2 0-100-44.8-100-100s44.8-100 100-100h132.8c22.1 0 40 17.9 40 40s-17.9 40-40 40h-134.8c-26.5 0-26.5 40 0 40h113.8c55.2 0 100 44.8 100 100s-44.8 100-100 100h-171.8c-22.1 0-40-17.9-40-40s17.9-40 40-40h173.9c26.5 0 26.5-40 0-40zM298 416c23.6-16 46.5-51.9 51.1-80h64.5c10.9-0.1 19.7-9 19.7-19.8v-0.2-120-0.2c0-10.9-8.8-19.7-19.7-19.8h-117.2c8.3-9.5 15-27.4 15-40s-6.7-30.5-15-40h136.9c43.4 0 78.7 35.8 78.7 80v160c0 44.2-35.2 80-78.7 80h-135.3z'
      }
    ]
  }
})
